import { lazy, Suspense } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { Loading } from '@/kit';
import { RequirePermissions } from '@/shared/components/RequirePermissions';
import { TRANSFER_NOTE_PERMISSIONS } from '@/domains/transferNotes/permissions';

// Bajo demanda y al ARCHIVO, no al barrel, para que la pantalla viva en su propio chunk.
const TransferNotesSkPage = lazy(() =>
    import('@/domains/transferNotes/TransferNotesSkPage').then((m) => ({
        default: m.TransferNotesSkPage,
    })),
);

// Ruta estática: gana sobre la dinámica hermana `$section`.
export const Route = createFileRoute('/_backoffice/credit/transfers')({
    component: CreditTransfers,
});

// Por URL directa también se exige el permiso de lectura: sin él la pantalla no se monta.
function CreditTransfers() {
    return (
        <RequirePermissions permissions={[TRANSFER_NOTE_PERMISSIONS.read]}>
            <Suspense fallback={<Loading fullScreen={false} className="py-16" />}>
                <TransferNotesSkPage />
            </Suspense>
        </RequirePermissions>
    );
}
